<app-modal [modalSize]="'modal-small'">
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{this.data}}</h5>
  </div>
  <div class="modal-footer">
    <div (click)="save()" class="btn btn-primary">Confirm</div>
    <div (click)="closeModal()" class="btn btn-cancel" data-bs-dismiss="modal">Cancel</div>
  </div>
</app-modal>
